<template>
  <v-jstree :data="jsData" @item-click="catClick"></v-jstree>
</template>
<script>
import { mapState } from "vuex";
import VJstree from "vue-jstree";

export default {
  components: { VJstree },
  computed: {
    ...mapState({
      categories: state => state.categories,
      filters: state => state.categories.filters,
      selected: state => state.categories.selected,
      selectedProd: state => state.categories.selectedProd
    })
  },
  data() {
    return {
      selectedId: 0
    };
  },
  methods: {
    catClick(node, item) {
      let category = {
        category: this.findCategory(this.categories.list, item.id),
        top: false
      };
      this.$store.dispatch("categories/selected", category);
      this.$router.replace({ name: "searchPage" });
    },

    convertToJs(category) {
      return {
        id: category.id,
        text: category.name,
        opened: false,
        children: category.subcategories.map(c => this.convertToJs(c))
      };
    },

    filterCategory(jsCategory) {
      if (
        this.filters.length == 0 ||
        this.filters.indexOf(jsCategory.id) >= 0
      ) {
        jsCategory.children = jsCategory.children.filter(c =>
          this.filterCategory(c)
        );
        return true;
      }
      return false;
    },

    filterSelected(jsCategory) {
      if (
        this.selectedProd.length == 0 ||
        this.selectedProd.indexOf(jsCategory.id) >= 0
      ) {
        jsCategory.children = jsCategory.children.filter(c =>
          this.filterSelected(c)
        );
        return true;
      }
      return false;
    },

    highlight(jsCategory) {
      if (this.selectedProd.indexOf(jsCategory.id) >= 0) {
        jsCategory.a_attr = 'class: "highlight"';
        jsCategory.children = jsCategory.children.filter(c =>
          this.filter(highlight(c))
        );
        return true;
      }
      return true;
    },

    openCategory(c) {
      if (c.id == this.selectedId) {
        c.opened = true;
      } else {
        c.children.forEach(c => this.openCategory(c));
        c.opened = c.children.filter(c => c.opened).length > 0;
      }
    },

    findCategory(list, id) {
      for (let cat of list) {
        if (cat.id == id) {
          return cat;
        }
        let child = this.findCategory(cat.subcategories, id);
        if (child) {
          return child;
        }
      }
      return null;
    },

    buildJsTree() {
      let list = this.categories.list.map(c => this.convertToJs(c));
      list = list.filter(c => this.filterCategory(c));
      //TODO : zmienić na higlight?
      // list = list.filter(c => this.filterSelected(c));
      list.forEach(c => this.openCategory(c));
      this.jsData = list;
    }
  },
  watch: {
    filters: function() {
      this.buildJsTree();
    },
    selected: function() {
      this.selectedId = this.selected ? this.selected.id : 0;
      this.buildJsTree();
    },
    selectedProd: function() {
      this.buildJsTree();
    }
  },
  data() {
    return {
      jsData: []
    };
  },
  async beforeMount() {
    await this.$store.dispatch("categories/requestData");
    this.selectedId = this.selected ? this.selected.id : 0;
    this.buildJsTree();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/categories/src/CategoryJsTree.vue